import type { Exercice, Mouvement } from '@mairistem/comptabilite';
import React from 'react';
import MouvementActionType from '../../../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type TreeviewActionResult from '../../../../../interfaces/pieces/TreeviewActionResult';
import DuplicationModal from '../../Bordereau/Modals/DuplicationModal';
import MouvementAnnulationRejetModal from './MouvementAnnulationRejetModal';
import MouvementDeleteModal from './MouvementDeleteModal';

interface MouvementModalProviderProps {
	treeViewAction: TreeviewActionResult<Mouvement>;
	onChange: any;
	mouvement: Partial<Mouvement>;
	exercice: Exercice;
	typePes?: string;
}

const MouvementModalProvider = ({
	treeViewAction,
	mouvement,
	onChange,
	exercice,
	typePes,
}: MouvementModalProviderProps) => {
	const [data, setData] = React.useState<any>(treeViewAction.extraProps);

	const handleCloseModal = (modalName: string): void => {
		setData((old) => ({ ...old, [modalName]: { visible: false } }));
	};

	React.useEffect(() => {
		setData(treeViewAction.extraProps);
	}, [treeViewAction.extraProps]);

	const isSuperUser: boolean = data?.isSuperUser;

	if (data?.deleteModal?.visible) {
		return (
			<MouvementDeleteModal
				isSuperUser={isSuperUser}
				onClose={() => handleCloseModal('deleteModal')}
				onChange={() => {
					onChange(MouvementActionType.DELETE, mouvement);
				}}
				visible={data.deleteModal?.visible}
			/>
		);
	}

	if (data?.mouvementDuplicationModal?.visible) {
		return (
			<DuplicationModal
				visible={data.mouvementDuplicationModal?.visible}
				onValidate={(mouvementCree) =>
					onChange(MouvementActionType.DUPLIQUER, mouvementCree)
				}
				onClose={() => handleCloseModal('mouvementDuplicationModal')}
				mouvement={mouvement}
				exercice={exercice}
				typePes={typePes}
			/>
		);
	}

	if (data?.mouvementAnnulationRejetModal?.visible) {
		return (
			<MouvementAnnulationRejetModal
				visible={data.mouvementAnnulationRejetModal?.visible}
				estRejet={data.mouvementAnnulationRejetModal?.estRejet}
				mouvement={mouvement}
				exercice={exercice}
				onValidate={(annulationRejet) =>
					onChange(
						data.mouvementAnnulationRejetModal?.typeAction,
						annulationRejet,
					)
				}
				onClose={() => handleCloseModal('mouvementAnnulationRejetModal')}
			/>
		);
	}

	return null;
};

export default MouvementModalProvider;
